import Tooltip from "bootstrap/js/dist/tooltip";
// Use "mounted" hook
export default {
    mounted(el, binding) {
        const tooltip = new Tooltip(el, {
            title: binding.value,
            trigger: "hover",
            placement: "top",
        });
        el._tooltip = tooltip;
    }
}